import React from "react";
import { AppContext } from "../AppContext.js";

import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { ConfigManager } from "../config/ConfigManager.js";
import { BaseBean, RestReportBean } from "../ds/client_ds.js";
import {
  AllBinCriteriaBean,
  BinInventoryForInventoryAdjustmentPrintRequest,
  BinInventoryPageListPrintRequest,
  FabricStyleBean,
  FabricStyleSearchCriteria,
  RestFabricStyleListBeanRequest,
  RestInventoryRollListRequest,
  RestPageListBean,
  RestReadRequest,
  RestSKUBatchInventoryBean,
  RestSKUBatchInventoryTrackListRequest,
  RollsSearchCriteria,
  SkuBatchInventoryPageListPrintRequest,
  SKUBatchInventoryPrintInputBean,
  SKUBatchInventoryPrintInputCriteria,
  SKUBatchInventoryTrackSearchCriteria,
  RestCustomerListRequest,
  CustomerSearchCriteria,
} from "../ds/ds.js";
import { DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  CollapseComponent,
  ColumnDefinition,
  InputTextbox,
  MultiViewPopup,
  ProgressBar,
  ShowError,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toCommaSeperatedAmount,
  toDownloadReportAddress,
} from "../gui_components/Util.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import {
  PopupFabricStyleModule,
  PopupInventoryAdjustmentModule,
  PopupInvoiceModule,
  PopupPickTicketModule,
  PopupPurchaseOrderModule,
  PopupPurchaseReceiptModule,
  PopupLogisticReceiptModule,
} from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { InventoryService } from "../services/InventoryService.js";
import { ReportService } from "../services/ReportService.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { CustomerService } from "../services/CustomerService.js";
import CustomTable from "../gui_components/CustomTable.js";
class BinLocationInventory extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "BinLocation Inventory Inquiry",
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowResetButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowExitButton: true,
      error_list: [],
      inquiryDataList: [],
      criteria: new RollsSearchCriteria(),
      isInquiryDatasFound: false,
      isShowAlert: false,
      alertType: "",
      alertMessage: [],
      success_list: [],
      isShowFabricStyleModule: false,
      isShowPurchaseOrderModule: false,
      isShowPurchaseReceiptModule: false,
      isShowInvoiceModule: false,
      isShowPickticketModule: false,
      isShowInventoryAdjustmentModule: false,
      moduleForPopup: [],
      warehouses: [],
      isShowRollPopup: false,
      skuBatchTrackDataList: [],
      inquiryData: null,
      isShowPrintRollButton: false,
      isShowInvAdjustmentButton: false,
      isShowPrintRollPopup: false,
      colorLookupHandler: null,
      isShowLookup: true,
      isShowBinLookup: false,
      binList: [],
      fabricStyleData: new FabricStyleBean(),
      fabricColourPageListForAutoCompleteList: new Array(),
      fabricPageListForAutoCompleteList: new Array(),
      showAutoCompleteFabricList: true,
      showAutoCompleteFabricColorList: true,
      locationPageListForAutoCompleteList: new Array(),
      showAutoCompleteLocationList: true,
      binLocationPageListForAutoCompleteList: new Array(),
      showAutoCompleteBinLocationList: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      showAutoCompleteList: false,
      fabricLookupHandler: null,
      warehouseLookupHandler: null,
      binLookupHandler: null,
      isShowColorLookup: false,
      isDisableFields: false,
      isShowAlert: false,
      isShowPopupAlert: false,
      isPopupAlert: false,
      printDataList: [],
      selectedRollSkuList: [],
      isShowMultiPrintPopup: false,
      roll_criteria: new SKUBatchInventoryPrintInputCriteria(),
      isCollapsible_open: true,
      order: "asc",
      sortField: "",
      is3PL: false,
      isShowAutoCompleteCustomerList: false,
      customerPageListForAutoCompleteList: new Array(),
      isShowLogisticReceiptModule: false,
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    const { cache } = appData;
    this.cache = cache;
    const attribute_cache = { ...cache };
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    let warehouses = attribute_cache.warehouses;
    if (!isEmptyArray(attribute_cache.warehouses)) {
      warehouses.map((attr) => {
        this.state.warehouses.push(attr);
      });
    }
    this.loadBinLocations();
    this.initLookupHandlers();
  }
  initLookupHandlers = () => {
    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,
      this.state.is3PL ? "Item" : "Fabric Style",
    );
    this.setState({ fabricLookupHandler: fabricLookupHandler });
    let warehouseLookupHandler = new GenericAttributeLookupHandler(
      this.state.warehouses,
      "Warehouse",
    );
    this.setState({ warehouseLookupHandler: warehouseLookupHandler });
    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "Customer",
    );
    this.setState({ customerLookupHandler: customerLookupHandler });
  };
  loadBinLocations = () => {
    let criteria = new AllBinCriteriaBean();
    criteria.companyCode = this.companyCode;
    InventoryService.getAllBinList(
      criteria,
      this.loadBinLocationResponse,
      this.errorCallBack,
    );
  };
  loadBinLocationResponse = (response) => {
    if (response.data != null && response.data.binInfoBean != null) {
      let binLists = new Array();
      if (!isEmptyArray(response.data.binInfoBean.bins)) {
        let binList = response.data.binInfoBean.bins;
        if (binList != null || !isEmptyArray(binList)) {
          binList.map((list, i) => {
            let bean = new BaseBean();
            bean.code = list;
            binLists.push(bean);
          });
          this.setState({
            isShowBinLookup: true,
            binList: binLists,
          });
        }
      }
      this.binLookup();
    }
  };
  binLookup = () => {
    let binLookupHandler = new GenericAttributeLookupHandler(
      this.state.binList,
      "Bin",
    );
    this.setState({ binLookupHandler: binLookupHandler });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        ),
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        ),
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  loadPage = () => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let isValid = false;
    isValid = this.validateBinLocationData(criteria);
    if (isValid) {
      let pageInput = new RestPageListBean();
      // pageInput.pageSize = 500;
      // pageInput.currentPage = 1;
      let listRequest = new RestInventoryRollListRequest();
      listRequest.searchCriteria = criteria;
      listRequest.pageInput = pageInput;

      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Executing ...",
      });
      this.loadBinInventoryInquiryList(listRequest);
    }
  };
  validateBinLocationData = (criteria) => {
    let isValidData = false;
    let err_list = [];
    let errorMessage = "";
    // if (criteria == null) {
    //   let errMsg = "Enter All Fields ";
    //   errorMessage = errorMessage + errMsg;
    //   err_list.push(errMsg);
    // } else {
    if (isEmptyString(criteria.binLocationCode)) {
      let errMsg = "binLocationCode is Required";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    }

    //  }
    if (err_list.length > 0) {
      isValidData = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
      });
    } else {
      isValidData = true;
      this.setState({ isShowAlert: false });
    }
    return isValidData;
  };
  loadBinInventoryInquiryList = (listRequest) => {
    if (SecurityAccessManager.BinInventoryInquiry_IsAccessible()) {
      InventoryService.getRollsForBinPageList(
        listRequest,
        this.loadBinInventoryPageResponse,
        this.errorCallBack,
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadBinInventoryPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (
      response.data != null &&
      response.data.skuBatchInventoryPageList != null
    ) {
      let skuBatchDataList = new Array();
      if (
        !isEmptyArray(
          response.data.skuBatchInventoryPageList.skuBatchInventories,
        )
      ) {
        skuBatchDataList =
          response.data.skuBatchInventoryPageList.skuBatchInventories;
        this.setState({
          isShowPDFButton: true,
          isShowExcelButton: true,
          isShowPrintRollButton: true,
          isShowInvAdjustmentButton: true,
        });
      }
      this.setState({
        isInquiryDatasFound: true,
        isShowResetButton: true,
        inquiryDataList: skuBatchDataList,
        isShowClearCriteriaButton: false,
        isShowLookup: false,
        isShowBinLookup: false,
        isShowColorLookup: false,
        isCollapsible_open: false,
      });
      this.disable();
    }
    this.setState({
      progressLoadingText: "",
      isShowProgressBarPopup: false,
    });
  };
  errorCallBack = (error) => {
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    ShowError("Error" + error);
  };
  generateBinLocationInventoryReport = (reportType) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating ...",
    });
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let pageInput = new RestPageListBean();
    pageInput.pageSize = 20;
    pageInput.currentPage = 1;
    let listRequest = new BinInventoryPageListPrintRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;
    listRequest.pageInput = pageInput;
    if (reportBean.reportType == 1) {
      if (SecurityAccessManager.BinInventoryInquiryPDFReport_IsAccessible()) {
        ReportService.getBinInventoryPageListPrintReport(
          listRequest,
          this.generateBinLocationInventoryPageResponse,
          this.errorCallBack,
        );
      } else {
        this.inValidAccess(2);
      }
    } else if (reportBean.reportType == 2) {
      if (SecurityAccessManager.BinInventoryInquiryExcelReport_IsAccessible()) {
        ReportService.getBinInventoryPageListPrintReport(
          listRequest,
          this.generateBinLocationInventoryPageResponseForExcel,
          this.errorCallBack,
        );
      } else {
        this.inValidAccess(3);
      }
    }
  };
  generateBinLocationInventoryPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        // window.open(this.report_url + reportFilePath);
        let downloadAddress = toDownloadReportAddress(
          reportFilePath,
          true,
          true,
          this.report_url,
        );
        window.open(downloadAddress, "_blank");
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generateBinLocationInventoryPageResponseForExcel = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        // window.open(this.report_url + reportFilePath);
        let downloadAddress = toDownloadReportAddress(
          reportFilePath,
          true,
          true,
          this.report_url,
        );
        window.open(downloadAddress, "_blank");
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };
  clearCriteria = () => {
    let criteria = new RollsSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleName = "";
    criteria.customerName = "";

    this.setState({
      criteria: criteria,
      isShowColorLookup: false,
      isCollapsible_open: true,
      isShowAutoCompleteCustomerList: false,
      customerPageListForAutoCompleteList: new Array(),
    });
    if (this.state.is3PL) {
      let fabricLookupHandler = new FabricStyleLookupHandler(
        this.companyCode,
        "Item",
      );
      this.setState({ fabricLookupHandler: fabricLookupHandler });
    }
    this.hideAlertCallBack();
  };
  resetInquiry = () => {
    let criteria = new RollsSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleName = "";
    criteria.customerName = "";
    this.setState({
      criteria: criteria,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      isShowPrintRollButton: false,
      isShowInvAdjustmentButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowColorLookup: false,
      isShowLookup: true,
      isShowBinLookup: true,
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isDisableFields: false,
      isCollapsible_open: true,
      isShowAutoCompleteCustomerList: false,
      customerPageListForAutoCompleteList: new Array(),
    });
    if (this.state.is3PL) {
      let fabricLookupHandler = new FabricStyleLookupHandler(
        this.companyCode,
        "Item",
      );
      this.setState({ fabricLookupHandler: fabricLookupHandler });
    }
    this.hideAlertCallBack();
  };
  generatePDF = () => {
    this.generateBinLocationInventoryReport(1);
  };
  generateExcel = () => {
    this.generateBinLocationInventoryReport(2);
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  viewFabricModule = (e, code) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowFabricStyleModule: true,
          moduleForPopup: (
            <PopupFabricStyleModule
              fabricStyleCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewPOModule = (e, code) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowPurchaseOrderModule: true,
          moduleForPopup: (
            <PopupPurchaseOrderModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewPurchaseReceiptModule = (e, code) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowPurchaseReceiptModule: true,
          moduleForPopup: (
            <PopupPurchaseReceiptModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewRollSkuList = (e, code, rowData) => {
    if (e.detail === 1) {
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Loading ...",
        inquiryData: rowData,
      });
      let tempCriteria = new SKUBatchInventoryTrackSearchCriteria();
      tempCriteria.companyCode = this.companyCode;
      tempCriteria.rollSkuNumber = code;
      tempCriteria.modificationTrackNumber = null;
      let pageInput = new RestPageListBean();
      pageInput.pageSize = 20;
      pageInput.currentPage = 1;
      let listRequest = new RestSKUBatchInventoryTrackListRequest();
      listRequest.searchCriteria = tempCriteria;
      listRequest.pageInput = pageInput;
      this.loadSkuBatchInventoryTrackInquiryList(listRequest);
    }
  };
  loadSkuBatchInventoryTrackInquiryList = (listRequest) => {
    if (SecurityAccessManager.BinInventoryInquiry_IsAccessible()) {
      InventoryService.getSkuBatchInventoryTrackPageList(
        listRequest,
        this.loadSkuBatchInventoryTrackPageResponse,
        this.errorCallBack,
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadSkuBatchInventoryTrackPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.inventoryTrackPageList != null) {
      let skuBatchTrackDataList = new Array();
      if (
        !isEmptyArray(
          response.data.inventoryTrackPageList.skuBatchInventoryTracks,
        )
      ) {
        skuBatchTrackDataList =
          response.data.inventoryTrackPageList.skuBatchInventoryTracks;
        this.setState({
          skuBatchTrackDataList: skuBatchTrackDataList,
          isShowRollPopup: true,
        });
      } else {
        let errList = [];
        errList.push("No Data Found");
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowFabricStyleModule: isOpen,
      isShowPurchaseOrderModule: isOpen,
      isShowPurchaseReceiptModule: isOpen,
      isShowInvoiceModule: isOpen,
      isShowPickticketModule: isOpen,
      isShowInventoryAdjustmentModule: isOpen,
      isShowLogisticReceiptModule: isOpen,
      moduleForPopup: [],
    });
  };
  viewModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (rowData.updateEntityType === "FabricStyleInventoryAdjustment") {
        if (code !== "" && code !== undefined) {
          this.setState({
            isShowInventoryAdjustmentModule: true,
            moduleForPopup: (
              <PopupInventoryAdjustmentModule
                code={code}
                onModuleExit={this.onPopupModalExit}
              />
            ),
          });
        }
      } else if (rowData.updateEntityType === "PurchaseOrderReceipt") {
        if (code !== "" && code !== undefined) {
          this.setState({
            isShowPurchaseReceiptModule: true,
            moduleForPopup: (
              <PopupPurchaseReceiptModule
                code={code}
                onModuleExit={this.onPopupModalExit}
              />
            ),
          });
        }
      } else if (rowData.updateEntityType === "Invoice") {
        if (code !== "" && code !== undefined) {
          this.setState({
            isShowInvoiceModule: true,
            moduleForPopup: (
              <PopupInvoiceModule
                invoiceCode={code}
                onModuleExit={this.onPopupModalExit}
              />
            ),
          });
        }
      } else if (rowData.updateEntityType === "PickTicket") {
        if (code !== "" && code !== undefined) {
          this.setState({
            isShowPickticketModule: true,
            moduleForPopup: (
              <PopupPickTicketModule
                pickTicketCode={code}
                onModuleExit={this.onPopupModalExit}
              />
            ),
          });
        }
      } else if (rowData.updateEntityType === "LogisticOrderReceipt") {
        if (code !== "" && code !== undefined) {
          this.setState({
            isShowLogisticReceiptModule: true,
            moduleForPopup: (
              <PopupLogisticReceiptModule
                code={code}
                onModuleExit={this.onPopupModalExit}
              />
            ),
          });
        }
      }
    }
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.setState({
      isShowRollPopup: isShowPopup,
      isShowPrintRollPopup: isShowPopup,
      selectedRollSkuList: new Array(),
    });
    this.hideAlertCallBack();
  };
  closeAlertPopupModalCallBack = (isShowPopup) => {
    this.setState({ isShowMultiPrintPopup: isShowPopup });
  };
  viewPrintRoll = (e) => {
    if (e.detail === 1) {
      this.printRollList();
      this.setState({ isShowPrintRollPopup: true });
    }
  };
  viewGenerateInvAdjustment = (e) => {
    if (e.detail === 1) {
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Generating ...",
      });
      let criteria = this.state.criteria;
      criteria.companyCode = this.companyCode;
      let reportBean = new RestReportBean();
      reportBean.reportType = 2;
      let pageInput = new RestPageListBean();
      pageInput.pageSize = 20;
      pageInput.currentPage = 1;
      let listRequest = new BinInventoryForInventoryAdjustmentPrintRequest();
      listRequest.criteria = criteria;
      listRequest.reportBean = reportBean;
      listRequest.pageInput = pageInput;
      if (!isEmptyArray(this.state.inquiryDataList)) {
        if (SecurityAccessManager.BinInventoryInquiry_IsAccessible()) {
          ReportService.getBinInventoryForInventoryAdjustmentPrintReport(
            listRequest,
            this.generateBinInventoryForInventoryAdjustmentPageResponse,
            this.errorCallBack,
          );
        } else {
          this.inValidAccess(1);
        }
      }
    }
  };
  generateBinInventoryForInventoryAdjustmentPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "'",
    });
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };
  fabricCodeOnChange = (e) => {
    let fabricStyleCode = e.target.value;
    this.state.showAutoCompleteFabricList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteFabricList;
    if (isEmptyString(fabricStyleCode)) {
      this.state.showAutoCompleteList = false;
      let showAutoCompleteList = this.state.showAutoCompleteFabricList;
      let criteria = this.state.criteria;
      criteria.fabricStyleCode = "";
      criteria.fabricStyleName = "";
      criteria.colorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
        isShowColorLookup: false,
      });
    } else if (
      e.target.name == "fabricStyleCode" &&
      showAutoCompleteList === true &&
      fabricStyleCode !== ""
    ) {
      this.readFabricBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readandsetFabricStyleDetailResponse = (response) => {
    let criteria = this.state.criteria;
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    if (response.data != null && response.data.fabricStyle != null) {
      let fabricStyle = response.data.fabricStyle;
      if (!isEmpty(fabricStyle)) {
        criteria.fabricStyleCode = fabricStyle.code;
        criteria.fabricStyleName = fabricStyle.description;
        let colors = fabricStyle.colors;
        let finalColorList = [];
        colors.map((ent) => {
          let colorBean = new BaseBean();
          colorBean.code = ent.fabricStyleColorCode;
          colorBean.description = ent.fabricStyleColorName;
          finalColorList.push(colorBean);
        });
        this.setState({ colorLookupHandler: null });
        if (finalColorList != null) {
          let colorLookupHandler = new GenericAttributeLookupHandler(
            finalColorList,
            "Color",
          );
          this.setState({
            colorLookupHandler: colorLookupHandler,
            isShowColorLookup: true,
            criteria: criteria,
            colorList: finalColorList,
            fabricStyleData: fabricStyle,
          });
        }
      }
    }
  };
  readandsetFabricStyleDetail = (fabricStyleCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = fabricStyleCode;
    input.isLoadChildren = true;
    FabricStyleService.readFabricStyle(
      input,
      this.readandsetFabricStyleDetailResponse,
      this.errorCallBack,
    );
  };
  readFabricBySearchString(searchString) {
    let searchCriteria = new FabricStyleSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCodeStartsWith = searchString;
    searchCriteria.fabricStyleNameStartsWith = searchString;
    let pageList = new RestPageListBean();
    pageList.pageSize = 100;
    let input = new RestFabricStyleListBeanRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    FabricStyleService.getActiveFabricStylesForAutoComplete(
      input,
      this.readByFabricCodeResponse,
      this.errorCallBack,
    );
  }
  readByFabricCodeResponse = (response) => {
    if (
      response.data != null &&
      response.data.fabricStylePageList != null &&
      response.data.fabricStylePageList.fabricStyles != null
    ) {
      let criteria = this.state.criteria;
      let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
      let simpleAutoCompleteList = new Array();
      if (fabricStyleData.length > 0 && fabricStyleData != null) {
        fabricStyleData.map((fabricStyle) => {
          if (this.state.is3PL) {
            if (!isEmptyString(criteria.logisticCustomerCode)) {
              if (fabricStyle.customerCode == criteria.logisticCustomerCode) {
                let simpleItemBean = {
                  code: fabricStyle.fabricStyleCode,
                  description: fabricStyle.fabricStyleName,
                };
                simpleAutoCompleteList.push(simpleItemBean);
              }
            } else {
              let simpleItemBean = {
                code: fabricStyle.fabricStyleCode,
                description: fabricStyle.fabricStyleName,
              };
              simpleAutoCompleteList.push(simpleItemBean);
            }
          } else {
            let simpleItemBean = {
              code: fabricStyle.fabricStyleCode,
              description: fabricStyle.fabricStyleName,
            };
            simpleAutoCompleteList.push(simpleItemBean);
          }
        });
      }
      this.setState({
        fabricPageListForAutoCompleteList: simpleAutoCompleteList,
      });
    }
  };
  fabricEnterKeyEventHandler = (e) => {
    let fabricStyleCode = e.target.value;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: this.state.is3PL ? "read Item" : "read Fabric",
    });
    this.readandsetFabricStyleDetail(fabricStyleCode);
    this.setState({ fabricPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricList: showAutoCompleteList });
  };
  onFabricColourCodeChange = (e) => {
    this.state.showAutoCompleteFabricColorList = true;
    let colorCode = e.target.value;
    let showAutoCompleteFabricColorList =
      this.state.showAutoCompleteFabricColorList;
    if (isEmpty(colorCode)) {
      this.state.showAutoCompleteFabricColorList = false;
      let showAutoCompleteFabricColorList =
        this.state.showAutoCompleteFabricColorList;
      let criteria = this.state.criteria;
      criteria.colorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricColorList: showAutoCompleteFabricColorList,
        criteria: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "colorCode" &&
      showAutoCompleteFabricColorList === true &&
      colorCode !== ""
    ) {
      this.readFabricColourBySearchString(e.target.value);
    }
  };
  readFabricColourBySearchString(searchString) {
    let criteria = this.state.criteria;
    criteria.colorCode = searchString;
    let colorList = this.state.colorList;
    let simpleAutoCompleteColorList = new Array();
    colorList.map((colorListData) => {
      let simpleColorBean = {
        code: colorListData.code,
        description: colorListData.description,
      };
      simpleAutoCompleteColorList.push(simpleColorBean);
    });
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteColorList.filter(
      (simpleAutoCompleteColorLists) =>
        simpleAutoCompleteColorLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      fabricColourPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  fabricColourEnterKeyEventHandler = (e) => {
    let fabricStyleColourCode = e.target.value;
    this.fabricStyleColorSelected(fabricStyleColourCode);
    this.setState({ fabricColourPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricColorList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricColorList: showAutoCompleteList });
  };
  fabricStyleColorSelected = (colorCode) => {
    let criteria = this.state.criteria;
    criteria.colorCode = colorCode;
    this.setState({ criteria: criteria });
  };
  locationCodeOnChange = (e) => {
    let locationCode = e.target.value;
    this.state.showAutoCompleteLocationList = true;
    let temp_criteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteLocationList;
    if (isEmptyString(locationCode)) {
      this.state.showAutoCompleteLocationList = false;
      let showAutoCompleteList = this.state.showAutoCompleteLocationList;
      let criteria = this.state.criteria;
      criteria.locationCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteLocationList: showAutoCompleteList,
        criteria: criteria,
        showAutoCompleteSalesPersonList: suggestion,
      });
    } else if (showAutoCompleteList === true && locationCode !== "") {
      this.readLocationBySearchString(locationCode);
    }
    temp_criteria[e.target.name] = e.target.value;
    this.setState({ criteria: temp_criteria });
  };
  readLocation = (locationCode) => {
    let locationBean = null;
    let locationData = null;
    this.state.warehouses.map((ln) => {
      if (ln.code === locationCode) {
        locationBean = ln;
        locationData = new BaseBean();
        locationData.code = ln.code;
        locationData.description = ln.description;
      }
    });
    if (!isEmpty(locationBean)) {
      let temp_criteria = this.state.criteria;
      temp_criteria.locationCode = locationBean.code;
      this.state.showAutoCompleteLocationList = false;
      let showAutoCompleteList = this.state.showAutoCompleteLocationList;
      this.setState({
        criteria: temp_criteria,
        showAutoCompleteList: showAutoCompleteList,
      });
    }
    this.setState({ locationList: locationBean, locationData: locationData });
  };
  readLocationBySearchString = (searchString) => {
    let locationData = this.state.warehouses;
    let simpleAutoCompleteList = new Array();
    if (locationData.length > 0 && locationData != null) {
      locationData.map((sp) => {
        let locationBean = {
          code: sp.code,
          description: sp.description,
        };
        simpleAutoCompleteList.push(locationBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (autoList) =>
        autoList.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({ locationPageListForAutoCompleteList: filteredSuggestions });
  };
  locationEnterKeyEventHandler = (e) => {
    let locationCode = e.target.value;
    this.readLocation(locationCode);
    this.setState({
      locationPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteLocationList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteLocationList: showAutoCompleteList });
  };
  binLocationCodeOnChange = (e) => {
    let locationCode = e.target.value;
    this.state.showAutoCompleteBinLocationList = true;
    let temp_criteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteBinLocationList;
    if (isEmptyString(locationCode)) {
      this.state.showAutoCompleteBinLocationList = false;
      let showAutoCompleteList = this.state.showAutoCompleteBinLocationList;
      let criteria = this.state.criteria;
      criteria.binLocationCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteBinLocationList: showAutoCompleteList,
        criteria: criteria,
        showAutoCompleteBinLocationList: suggestion,
      });
    } else if (showAutoCompleteList === true && locationCode !== "") {
      this.readBinLocationBySearchString(locationCode);
    }
    temp_criteria[e.target.name] = e.target.value;
    this.setState({ criteria: temp_criteria });
  };
  readBinLocation = (locationCode) => {
    let locationBean = null;
    this.state.binList.map((ln) => {
      if (ln.code === locationCode) {
        locationBean = ln;
      }
    });
    if (!isEmpty(locationBean)) {
      let temp_criteria = this.state.criteria;
      temp_criteria.binLocationCode = locationBean.code;
      this.state.showAutoCompleteBinLocationList = false;
      let showAutoCompleteList = this.state.showAutoCompleteBinLocationList;
      this.setState({
        criteria: temp_criteria,
        showAutoCompleteBinLocationList: showAutoCompleteList,
      });
    }
    this.setState({ locationList: locationBean });
  };
  readBinLocationBySearchString = (searchString) => {
    let locationData = this.state.binList;
    let simpleAutoCompleteList = new Array();
    if (locationData.length > 0 && locationData != null) {
      locationData.map((sp) => {
        let locationBean = {
          code: sp.code,
          description: sp.description,
        };
        simpleAutoCompleteList.push(locationBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (autoList) =>
        autoList.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      binLocationPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  binLocationEnterKeyEventHandler = (e) => {
    let locationCode = e.target.value;
    this.readBinLocation(locationCode);
    this.setState({
      binLocationPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteBinLocationList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteBinLocationList: showAutoCompleteList });
  };
  printRollList = () => {
    let inquiryDataList = this.state.inquiryDataList;
    let printList = [];
    for (let list of inquiryDataList) {
      if (list.onHandQuantity != 0) {
        let rollInventory = new RestSKUBatchInventoryBean();
        rollInventory.companyCode = this.companyCode;
        rollInventory.rollSkuNumber = list.rollSkuNumber;
        rollInventory.rollNumber = list.rollNumber;
        rollInventory.skuNumber = list.skuNumber;
        rollInventory.locationCode = list.locationCode;
        rollInventory.aisleInfoText = list.aisleInfoText;
        rollInventory.referenceEntityType = list.referenceEntityType;
        rollInventory.referenceEntityNumber = list.referenceEntityNumber;
        rollInventory.uomCode = list.uomCode;
        rollInventory.currencyCode = list.currencyCode;
        rollInventory.onHandQuantity = list.onHandQuantity;
        rollInventory.receivedQuantity = list.receivedQuantity;
        rollInventory.cost = list.cost;
        rollInventory.fabricStyleCode = list.fabricStyleCode;
        rollInventory.fabricStyleName = list.fabricStyleName;
        rollInventory.fabricStyleColorCode = list.fabricStyleColorCode;
        rollInventory.widthCode = list.widthCode;
        rollInventory.batchBarCode = list.batchBarCode;
        rollInventory.purchaseOrderNumber = list.purchaseOrderNumber;
        rollInventory.purchaseOrderReceiptNumber =
          list.purchaseOrderReceiptNumber;
        rollInventory.rollBarCode = list.rollBarCode;
        rollInventory.vendorBatchNumber = list.vendorBatchNumber;
        rollInventory.boxNumber = list.boxNumber;
        rollInventory.receivedDate = list.receivedDate;
        printList.push(rollInventory);
      }
    }
    this.setState({ printDataList: printList });
  };
  rollLineCheck = (e, rowData) => {
    rowData.isActive = e.target.value;
    let selectedLine = this.state.selectedRollSkuList;
    if (rowData.isActive === true) {
      selectedLine.push(rowData);
      this.setState({ selectedRollSkuList: selectedLine });
    } else {
      let selectedRollSkuList = this.state.selectedRollSkuList;
      let rollList = [];
      for (let roll of selectedRollSkuList) {
        if (roll.isActive != rowData.isActive) {
          rollList.push(roll);
          this.setState({ selectedRollSkuList: rollList });
        } else if (selectedRollSkuList.length == 1) {
          this.setState({ selectedRollSkuList: [] });
        }
      }
    }
  };
  selectLine = () => {
    let selectedRollSkuList = this.state.selectedRollSkuList;
    let rollList = [];
    for (let roll of selectedRollSkuList) {
      if (roll.isActive == true) {
        roll.isActive = false;
        rollList.push(roll);
        this.setState({ selectedRollSkuList: rollList });
      }
    }
  };
  columnDefinitions = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("", "isActive", false)
        .setInputDetails(false, false, true, false, this.rollLineCheck, null),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Inventory#" : "RollSKU",
          "rollSkuNumber",
          true,
        )
        .setStyleDetails("left"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Location", "locationCode", true)
        .setStyleDetails("left"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("VendorLot#", "vendorBatchNumber", true)
        .setStyleDetails("right"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Box", "boxNumber", true)
        .setStyleDetails("right"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PO", "purchaseOrderNumber", true)
        .setStyleDetails("left"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PO Recipt", "purchaseOrderReceiptNumber", true)
        .setStyleDetails("left"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OnHandQty", "onHandQuantity", true)
        .setStyleDetails("right"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("BinLoc", "aisleInfoText", true)
        .setStyleDetails("left"),
    );

    return columns;
  };

  // columnDefinitions = () => {
  //   let columnList = [];
  //   columnList.push(
  //     new DataGridColumnDefinition()
  //       .setDetails("", "isActive", 0, false, null, false, null)
  //       .setEditableDetails(
  //         false,
  //         "",
  //         null,
  //         false,
  //         null,
  //         true,
  //         this.rollLineCheck
  //       )
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails(
  //       this.state.is3PL ? "Inventory#" : "RollSKU#",
  //       "rollSkuNumber"
  //     )
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("Location", "locationCode")
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails(
  //       "VendorLot#",
  //       "vendorBatchNumber"
  //     )
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("Roll#", "rollNumber")
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("Box#", "boxNumber")
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("PO#", "purchaseOrderNumber")
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails(
  //       "PO Recipt#",
  //       "purchaseOrderReceiptNumber"
  //     )
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("OnHandQty#", "onHandQuantity")
  //   );
  //   columnList.push(
  //     new DataGridColumnDefinition().setDetails("BinLoc#", "aisleInfoText")
  //   );

  //   return columnList;
  // };
  lineSelectAll = (e) => {
    if (e.detail <= 1) {
      let list = this.state.printDataList;
      list.map((line) => {
        line.isActive = true;
      });
      this.setState({ selectedRollSkuList: list });
    }
  };
  lineUnSelectAll = (e) => {
    if (e.detail <= 1) {
      let list = this.state.printDataList;
      list.map((line, i) => {
        line.isActive = false;
      });
      this.setState({ selectedRollSkuList: [] });
    }
  };
  generateMultiPDF = (e) => {
    if (e.detail <= 1) {
      let selectedRollSkuList = this.state.selectedRollSkuList;
      if (!isEmptyArray(selectedRollSkuList)) {
        let rollSkuList = new Array();
        for (let list of selectedRollSkuList) {
          let inputBean = new SKUBatchInventoryPrintInputBean();
          inputBean.rollSkuNumber = list.rollSkuNumber;
          inputBean.locationCode = list.locationCode;
          rollSkuList.push(inputBean);
        }
        this.setState({ isShowMultiPrintPopup: true });
      } else {
        let errMsg = "Select the Line";
        let err = [];
        err.push(errMsg);
        this.setState({
          alertMessage: err,
          alertType: "danger",
          isShowPopupAlert: true,
        });
      }
    }
  };
  generateMultiPrint = (e) => {
    if (e.detail === 1) {
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Executing ...",
      });
      let selectedRollSkuList = this.state.selectedRollSkuList;
      let rollSkuList = new Array();
      for (let list of selectedRollSkuList) {
        let inputBean = new SKUBatchInventoryPrintInputBean();
        inputBean.rollSkuNumber = list.rollSkuNumber;
        inputBean.locationCode = list.locationCode;
        rollSkuList.push(inputBean);
      }
      let roll_criteria = this.state.roll_criteria;
      roll_criteria.companyCode = this.companyCode;
      roll_criteria.rollSkuList = rollSkuList;
      let reportBean = new RestReportBean();
      reportBean.reportType = 1;
      let pageInput = new RestPageListBean();
      pageInput.pageSize = 20;
      pageInput.currentPage = 1;
      if (roll_criteria.noOfCopies != 0) {
        let listRequest = new SkuBatchInventoryPageListPrintRequest();
        listRequest.criteria = roll_criteria;
        listRequest.reportBean = reportBean;
        listRequest.pageInput = pageInput;
        if (SecurityAccessManager.BinInventoryInquiryPDFReport_IsAccessible()) {
          ReportService.generateMultiRollSkuEntityPrintReport(
            listRequest,
            this.generateMultiPrintResponse,
            this.errorCallBack,
          );
        } else {
          this.inValidAccess(1);
        }
      } else {
        let errMsg = "Enter the value";
        let err = [];
        err.push(errMsg);
        this.setState({
          alertMessage: err,
          alertType: "danger",
          isPopupAlert: true,
        });
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
  };
  generateMultiPrintResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data && response.data.reportResult) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.selectLine();
    let selectedRollSkuList = new Array();
    let roll_criteria = this.state.roll_criteria;
    roll_criteria.noOfCopies = 0;
    this.setState({
      isShowMultiPrintPopup: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      selectedRollSkuList: selectedRollSkuList,
      roll_criteria: roll_criteria,
    });
  };
  onPrintChange = (e) => {
    let roll_criteria = this.state.roll_criteria;
    roll_criteria[e.target.name] = e.target.value;
    this.setState({ roll_criteria: roll_criteria });
  };
  hideAlertPopupCallBack = (msgType, isDisplayed) => {
    this.setState({
      isShowPopupAlert: isDisplayed,
      isPopupAlert: isDisplayed,
      error_list: [],
    });
  };
  showHideSecondHeader = (e) => {
    if (e.detail === 1) {
      let isCollapsible_open = !this.state.isCollapsible_open;
      this.setState({ isCollapsible_open: isCollapsible_open });
    }
  };

  handleSortingChange = (e, accessor) => {
    if (e.detail === 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSorting(sortField, sortOrder);
    }
  };
  handleSorting = (sortField, sortOrder) => {
    let list = this.state.inquiryDataList;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ inquiryDataList: sorted });
    }
  };

  handleSortingSkuTrackChange = (e, accessor) => {
    if (e.detail === 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSortingSkuTrack(sortField, sortOrder);
    }
  };
  handleSortingSkuTrack = (sortField, sortOrder) => {
    let list = this.state.skuBatchTrackDataList;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ skuBatchTrackDataList: sorted });
    }
  };
  graphValueProvider = (rowData) => {
    if (
      parseFloat(rowData.onHandQuantity) >= parseFloat(rowData.receivedQuantity)
    ) {
      return <div className="square-fill-blue"></div>;
    } else {
      return <div className="square-partial-yellow"></div>;
    }
  };

  onCustomerCodeChange = (e) => {
    let logisticCustomerCode = e.target.value.toUpperCase();
    this.state.isShowAutoCompleteCustomerList = true;
    let criteria = this.state.criteria;
    let showAutoCompleteList = this.state.isShowAutoCompleteCustomerList;
    if (isEmpty(logisticCustomerCode)) {
      this.state.isShowAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteCustomerList;
      let temp_criteria = this.state.criteria;
      temp_criteria.logisticCustomerCode = "";
      temp_criteria.customerName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: temp_criteria,
        customerPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "logisticCustomerCode" &&
      showAutoCompleteList === true &&
      logisticCustomerCode !== ""
    ) {
      this.readCustomerBySearchString(e.target.value);
    }
    criteria[e.target.name] = e.target.value.toUpperCase();
    this.setState({ criteria: criteria });
  };
  customerCodeEnterKeyEventHandler = (e) => {
    let logisticCustomerCode = e.target.value;
    this.readCustomer(logisticCustomerCode);
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
    });
  };

  readCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new RestPageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;

    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.readByCustomerCodeResponse,
      this.errorCallBack,
    );
  }
  readByCustomerCodeResponse = (response) => {
    let customerData = response.data.customerPageList.customers;
    let simpleAutoCompleteList = new Array();
    if (customerData.length > 0 && customerData != null) {
      customerData.map((customer) => {
        let simpleItemBean = {
          code: customer.code,
          description: customer.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      customerPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };

  readCustomerResponse = (response) => {
    const customerData = response.data.customer;
    if (customerData != null) {
      let criteria = this.state.criteria;
      criteria.logisticCustomerCode = customerData.code;
      criteria.customerName = customerData.description;
      this.setState({ criteria: criteria });

      if (this.state.is3PL) {
        let fabricLookupHandler = new FabricStyleLookupHandler(
          this.companyCode,
          "Item",
          criteria.logisticCustomerCode,
        );
        this.setState({ fabricLookupHandler: fabricLookupHandler });
      }
    }
  };

  readCustomer = (logisticCustomerCode) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = logisticCustomerCode;
    readrestInput.isLoadChildren = true;

    CustomerService.readCustomerWithChildren(
      readrestInput,
      this.readCustomerResponse,
      this.errorCallBack,
    );
  };

  displayAutoCompleteCustomerList = (showAutoCompleteList) => {
    this.setState({ isShowAutoCompleteCustomerList: showAutoCompleteList });
  };

  render() {
    let inquiryDataList = this.state.inquiryDataList;
    let skuBatchTrackDataList = this.state.skuBatchTrackDataList;
    let inquiryData = this.state.inquiryData;
    let printDataList = this.state.printDataList;
    let roll_criteria = this.state.roll_criteria;
    let criteria = this.state.criteria;
    var dataTableStyles = {
      header: {
        style: {
          minHeight: "0px",
        },
      },
      table: {
        style: {
          minHeight: "350px",
          maxHeight: "350px",
          overflowY: "auto",
        },
      },
    };

    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          pageTitle={this.state.pageTitle}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          isShowExitButton={this.state.isShowExitButton}
          onModuleExit={this.onModuleExit}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          reset={this.resetInquiry}
          generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
          extend_toolbar={
            <>
              {this.state.isShowPrintRollButton && (
                <Button
                  className="header_buttons secondary"
                  size="sm"
                  onClick={(e) => this.viewPrintRoll(e)}
                >
                  Print Rolls
                </Button>
              )}
              {this.state.isShowInvAdjustmentButton && (
                <Button
                  className="header_buttons secondary"
                  size="sm"
                  onClick={(e) => this.viewGenerateInvAdjustment(e)}
                >
                  Generate InvAdjustment Excel
                </Button>
              )}
            </>
          }
        />
        <CriteriaView
          {...this.state}
          loadPage={this.loadPage}
          onChange={this.onChange}
          fabricCodeOnChange={this.fabricCodeOnChange}
          fabricEnterKeyEventHandler={this.fabricEnterKeyEventHandler}
          displayAutoCompleteFabricList={this.displayAutoCompleteFabricList}
          fabricColourEnterKeyEventHandler={
            this.fabricColourEnterKeyEventHandler
          }
          displayAutoCompleteFabricColorList={
            this.displayAutoCompleteFabricColorList
          }
          onFabricColourCodeChange={this.onFabricColourCodeChange}
          locationEnterKeyEventHandler={this.locationEnterKeyEventHandler}
          displayAutoCompleteLocationList={this.displayAutoCompleteLocationList}
          locationCodeOnChange={this.locationCodeOnChange}
          binLocationEnterKeyEventHandler={this.binLocationEnterKeyEventHandler}
          displayAutoCompleteBinLocationList={
            this.displayAutoCompleteBinLocationList
          }
          binLocationCodeOnChange={this.binLocationCodeOnChange}
          showHideSecondHeader={this.showHideSecondHeader}
          onCustomerCodeChange={this.onCustomerCodeChange}
          customerCodeEnterKeyEventHandler={
            this.customerCodeEnterKeyEventHandler
          }
          displayAutoCompleteCustomerList={this.displayAutoCompleteCustomerList}
        />

        {this.state.isInquiryDatasFound && (
          <div className="div_default">
            <Table id="fabrics_tables">
              <thead>
                <th
                  onClick={(e) => this.handleSortingChange(e, "aisleInfoText")}
                >
                  BinLoc#
                  {this.state.order === "desc" &&
                  this.state.sortField === "aisleInfoText" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "fabricStyleCode")
                  }
                >
                  {this.state.is3PL ? "Item#" : "FabricStyle#"}
                  {this.state.order === "desc" &&
                  this.state.sortField === "fabricStyleCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "fabricStyleName")
                  }
                >
                  {this.state.is3PL ? "Item Name" : "FabricStyle Name"}
                  {this.state.order === "desc" &&
                  this.state.sortField === "fabricStyleName" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "fabricStyleColorCode")
                  }
                >
                  Color
                  {this.state.order === "desc" &&
                  this.state.sortField === "fabricStyleColorCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "skuNumber")}>
                  SKU
                  {this.state.order === "desc" &&
                  this.state.sortField === "skuNumber" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) => this.handleSortingChange(e, "rollSkuNumber")}
                >
                  {this.state.is3PL ? "Inventory#" : "RollSKU#"}
                  {this.state.order === "desc" &&
                  this.state.sortField === "rollSkuNumber" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) => this.handleSortingChange(e, "locationCode")}
                >
                  Location
                  {this.state.order === "desc" &&
                  this.state.sortField === "locationCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "vendorBatchNumber")
                  }
                >
                  LotNumber
                  {this.state.order === "desc" &&
                  this.state.sortField === "vendorBatchNumber" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "rollNumber")}>
                  RollNumber
                  {this.state.order === "desc" &&
                  this.state.sortField === "rollNumber" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "purchaseOrderNumber")
                  }
                >
                  PO#
                  {this.state.order === "desc" &&
                  this.state.sortField === "purchaseOrderNumber" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "purchaseOrderReceiptNumber")
                  }
                >
                  Receipt#
                  {this.state.order === "desc" &&
                  this.state.sortField === "purchaseOrderReceiptNumber" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "uomCode")}>
                  UOM
                  {this.state.order === "desc" &&
                  this.state.sortField === "uomCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) => this.handleSortingChange(e, "onHandQuantity")}
                >
                  OnHandQty
                  {this.state.order === "desc" &&
                  this.state.sortField === "onHandQuantity" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th></th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(
                      e,
                      "lastPhysicalInventoryVerificationDate",
                    )
                  }
                >
                  VerifyDate
                  {this.state.order === "desc" &&
                  this.state.sortField ===
                    "lastPhysicalInventoryVerificationDate" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
              </thead>
              {inquiryDataList != null && (
                <tbody>
                  {inquiryDataList.map((list, index) => (
                    <tr key={index}>
                      <td>{list.aisleInfoText} </td>
                      <td>
                        <Button
                          size="sm"
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) =>
                            this.viewFabricModule(e, list.fabricStyleCode)
                          }
                        >
                          {list.fabricStyleCode}
                        </Button>
                      </td>
                      <td>{list.fabricStyleName} </td>
                      <td>{list.fabricStyleColorCode} </td>
                      <td className="text-right">{list.skuNumber} </td>
                      <td>
                        <Button
                          size="sm"
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) =>
                            this.viewRollSkuList(e, list.rollSkuNumber, list)
                          }
                        >
                          {list.rollSkuNumber}
                        </Button>
                      </td>
                      <td>{list.locationCode} </td>
                      <td>{list.vendorBatchNumber} </td>
                      <td>{list.rollNumber} </td>
                      <td>
                        <Button
                          size="sm"
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) =>
                            this.viewPOModule(e, list.purchaseOrderNumber)
                          }
                        >
                          {list.purchaseOrderNumber}
                        </Button>
                      </td>
                      <td>
                        <Button
                          size="sm"
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) =>
                            this.viewPurchaseReceiptModule(
                              e,
                              list.purchaseOrderReceiptNumber,
                            )
                          }
                        >
                          {list.purchaseOrderReceiptNumber}
                        </Button>
                      </td>
                      <td>{list.uomCode} </td>
                      <td className="text-right">
                        {toCommaSeperatedAmount(list.onHandQuantity)}{" "}
                      </td>
                      <td className="grap-wrap">
                        {this.graphValueProvider(list)}
                      </td>
                      <td>{list.lastPhysicalInventoryVerificationDate}</td>
                    </tr>
                  ))}
                </tbody>
              )}
            </Table>
            {inquiryDataList.length != 0 ? null : (
              <div className="no_Data">{"No Data"}</div>
            )}
          </div>
        )}
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowRollPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"RollSkuTrackDetails"}
          closeOnDocumentClick={false}
          popupLvlClass={"popupSizeLevel0"}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          content={
            <div className="">
              <div>
                {inquiryData != null && (
                  <div>
                    <Row>
                      <Col sm="1">
                        <FormLabel>company Code</FormLabel>
                      </Col>
                      <Col sm="2">
                        <InputTextbox
                          value={inquiryData.companyCode}
                          disabled={true}
                        />
                      </Col>
                      <Col sm="1">
                        {this.state.is3PL ? (
                          <FormLabel>Item</FormLabel>
                        ) : (
                          <FormLabel>FabricStyle</FormLabel>
                        )}
                      </Col>
                      <Col sm="2">
                        <InputTextbox
                          value={inquiryData.fabricStyleCode}
                          disabled={true}
                        />
                      </Col>
                      <Col sm="2">
                        <InputTextbox
                          value={inquiryData.fabricStyleName}
                          disabled={true}
                        />
                      </Col>
                      <Col sm="1">
                        <FormLabel>Color</FormLabel>
                      </Col>
                      <Col sm="2">
                        <InputTextbox
                          value={inquiryData.fabricStyleColorCode}
                          disabled={true}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="1">
                        <FormLabel>Width</FormLabel>
                      </Col>
                      <Col sm="2">
                        <InputTextbox
                          value={inquiryData.widthCode}
                          disabled={true}
                        />
                      </Col>
                      <Col sm="1">
                        <FormLabel>UOM</FormLabel>
                      </Col>
                      <Col sm="2">
                        <InputTextbox
                          value={inquiryData.uomCode}
                          disabled={true}
                        />
                      </Col>
                    </Row>
                  </div>
                )}
                <div className="div_default">
                  <Row>
                    <Table id="fabrics_tables">
                      <thead>
                        <th
                          rowspan="2"
                          onClick={(e) =>
                            this.handleSortingSkuTrackChange(
                              e,
                              "fabricStyleCode",
                            )
                          }
                        >
                          {this.state.is3PL ? "Item#" : "FabricStyle#"}
                          {this.state.order === "desc" &&
                          this.state.sortField === "fabricStyleCode" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                        <th
                          rowspan="2"
                          onClick={(e) =>
                            this.handleSortingSkuTrackChange(
                              e,
                              "fabricStyleName",
                            )
                          }
                        >
                          {this.state.is3PL ? "Item Name" : "FabricStyle Name"}
                          {this.state.order === "desc" &&
                          this.state.sortField === "fabricStyleName" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                        <th
                          rowspan="2"
                          onClick={(e) =>
                            this.handleSortingSkuTrackChange(
                              e,
                              "fabricStyleColorCode",
                            )
                          }
                        >
                          {" "}
                          Color
                          {this.state.order === "desc" &&
                          this.state.sortField === "fabricStyleColorCode" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                        <th
                          rowspan="2"
                          onClick={(e) =>
                            this.handleSortingSkuTrackChange(e, "rollSkuNumber")
                          }
                        >
                          {" "}
                          {this.state.is3PL ? "Inventory#" : "RollSKU#"}
                          {this.state.order === "desc" &&
                          this.state.sortField === "rollSkuNumber" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                        <th
                          rowspan="2"
                          onClick={(e) =>
                            this.handleSortingSkuTrackChange(e, "locationCode")
                          }
                        >
                          {" "}
                          Location
                          {this.state.order === "desc" &&
                          this.state.sortField === "locationCode" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                        <th
                          rowspan="2"
                          onClick={(e) =>
                            this.handleSortingSkuTrackChange(
                              e,
                              "vendorBatchNumber",
                            )
                          }
                        >
                          {" "}
                          Lot Number
                          {this.state.order === "desc" &&
                          this.state.sortField === "vendorBatchNumber" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                        <th
                          rowspan="2"
                          onClick={(e) =>
                            this.handleSortingSkuTrackChange(e, "rollNumber")
                          }
                        >
                          {" "}
                          RollNumber
                          {this.state.order === "desc" &&
                          this.state.sortField === "rollNumber" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                        <th
                          rowspan="2"
                          onClick={(e) =>
                            this.handleSortingSkuTrackChange(e, "uomCode")
                          }
                        >
                          {" "}
                          UOM
                          {this.state.order === "desc" &&
                          this.state.sortField === "uomCode" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                        <th colspan="3">onHandQuantity</th>
                        <th rowspan="2">Process</th>
                        <th
                          rowspan="2"
                          onClick={(e) =>
                            this.handleSortingSkuTrackChange(e, "createdDate")
                          }
                        >
                          {" "}
                          Date
                          {this.state.order === "desc" &&
                          this.state.sortField === "createdDate" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                        <tr>
                          <th
                            scope="col"
                            onClick={(e) =>
                              this.handleSortingSkuTrackChange(
                                e,
                                "previousOnHandQuantity",
                              )
                            }
                          >
                            {" "}
                            Open
                            {this.state.order === "desc" &&
                            this.state.sortField ===
                              "previousOnHandQuantity" ? (
                              <span className="drp-dwn-cntr">
                                <DropDwnUp />
                              </span>
                            ) : (
                              <span className="drp-dwn-cntr">
                                <DropDwnDown />
                              </span>
                            )}
                          </th>
                          <th
                            scope="col"
                            onClick={(e) =>
                              this.handleSortingSkuTrackChange(
                                e,
                                "changeOnHandQuantity",
                              )
                            }
                          >
                            {" "}
                            Change
                            {this.state.order === "desc" &&
                            this.state.sortField === "changeOnHandQuantity" ? (
                              <span className="drp-dwn-cntr">
                                <DropDwnUp />
                              </span>
                            ) : (
                              <span className="drp-dwn-cntr">
                                <DropDwnDown />
                              </span>
                            )}
                          </th>
                          <th
                            scope="col"
                            onClick={(e) =>
                              this.handleSortingSkuTrackChange(
                                e,
                                "onHandQuantity",
                              )
                            }
                          >
                            {" "}
                            Close
                            {this.state.order === "desc" &&
                            this.state.sortField === "onHandQuantity" ? (
                              <span className="drp-dwn-cntr">
                                <DropDwnUp />
                              </span>
                            ) : (
                              <span className="drp-dwn-cntr">
                                <DropDwnDown />
                              </span>
                            )}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {skuBatchTrackDataList.map((data, index) => (
                          <tr key={index}>
                            <td>{data.fabricStyleCode}</td>
                            <td>{data.fabricStyleName}</td>
                            <td>{data.fabricStyleColorCode}</td>
                            <td className="text-right">{data.rollSkuNumber}</td>
                            <td>{data.locationCode}</td>
                            <td>{data.vendorBatchNumber}</td>
                            <td>{data.rollNumber}</td>
                            <td>{data.uomCode}</td>
                            <td className="text-right">
                              {toCommaSeperatedAmount(
                                data.previousOnHandQuantity,
                              )}
                            </td>
                            <td className="text-right">
                              {toCommaSeperatedAmount(
                                data.changeOnHandQuantity,
                              )}
                            </td>
                            <td className="text-right">
                              {toCommaSeperatedAmount(data.onHandQuantity)}
                            </td>
                            <td>
                              <Button
                                size="sm"
                                variant="secondry"
                                className="hyperLinkText"
                                onClick={(e) =>
                                  this.viewModule(
                                    e,
                                    data.updateEntityCode,
                                    data,
                                  )
                                }
                              >
                                {data.updateEntityCode}-{data.updateEntityType}
                              </Button>
                            </td>
                            <td>{data.createdDate}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                    {skuBatchTrackDataList.length != 0 ? null : (
                      <div className="no_Data">{"No Data"}</div>
                    )}
                  </Row>
                </div>
              </div>
            </div>
          }
        />
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowPrintRollPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          popupLvlClass={"popupSizeLevel0"}
          title={"PrintRollLines"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowPopupAlert}
              hideAlertCallBack={this.hideAlertPopupCallBack}
            />
          }
          content={
            <div className="">
              <div>
                <Row>
                  <Col sm="1">
                    <FormLabel> CompanyCode</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      value={criteria.companyCode}
                      disabled={true}
                    />
                  </Col>
                  <Col sm="1">
                    {this.state.is3PL ? (
                      <FormLabel>Item</FormLabel>
                    ) : (
                      <FormLabel>FabricStyle</FormLabel>
                    )}
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      value={criteria.fabricStyleCode}
                      disabled={true}
                    />
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      value={criteria.fabricStyleName}
                      disabled={true}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel> Color</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox value={criteria.colorCode} disabled={true} />
                  </Col>
                </Row>
                <Row>
                  <Col sm="1">
                    <FormLabel> WareHouse</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      value={criteria.locationCode}
                      disabled={true}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel> Bin loc</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      value={criteria.binLocationCode}
                      disabled={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <b>OnHandQty OnRolls </b>
                  </Col>
                  <Col sm="2">
                    <Button
                      size="sm"
                      id="fabric_Add_Button"
                      className="enterFocus"
                      onClick={this.lineSelectAll}
                    >
                      {" "}
                      Select All{" "}
                    </Button>
                  </Col>
                  <Col sm="2">
                    <Button
                      size="sm"
                      id="fabric_Add_Button"
                      className="enterFocus"
                      onClick={this.lineUnSelectAll}
                    >
                      {" "}
                      UnSelect All{" "}
                    </Button>
                  </Col>
                  <Col sm="1">
                    <Button
                      size="sm"
                      id="fabric_Add_Button"
                      className="enterFocus"
                      onClick={this.generateMultiPDF}
                    >
                      MultiPrint
                    </Button>
                  </Col>
                </Row>

                <CustomTable
                  data={printDataList}
                  columns={this.columnDefinitions()}
                  label={"Print Data List"}
                />
              </div>
            </div>
          }
        />
        <MultiViewPopup
          isShowPopup={this.state.isShowMultiPrintPopup}
          title={"PrintRollsCopiesSelection"}
          closeOnEsc={false}
          closeOnDocumentClick={false}
          popupLvlClass={"popupSizeLevel5"}
          lineFunctionalityForm={this.lineFunctionalityForm}
          closeAlertModalCallBack={this.closeAlertPopupModalCallBack}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isPopupAlert}
              hideAlertCallBack={this.hideAlertPopupCallBack}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                size="1"
                onClick={(e) => this.generateMultiPrint(e)}
              >
                Print
              </Button>
            </div>
          }
          content={
            <div className="">
              <Row>
                <Col sm="2">
                  <FormLabel>No.Of.Copies</FormLabel>
                </Col>

                <Col sm="2">
                  <InputTextbox
                    name="noOfCopies"
                    value={roll_criteria.noOfCopies}
                    onChange={this.onPrintChange}
                  />
                </Col>
              </Row>
            </div>
          }
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowFabricStyleModule}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel0"}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowPurchaseOrderModule}
          popupLvlClass={"popupSizeLevel0"}
          closeOnEsc={false}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowPurchaseReceiptModule}
          popupLvlClass={"popupSizeLevel0"}
          closeOnEsc={false}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowInvoiceModule}
          popupLvlClass={"popupSizeLevel0"}
          closeOnEsc={false}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowPickticketModule}
          popupLvlClass={"popupSizeLevel0"}
          closeOnEsc={false}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowLogisticReceiptModule}
          popupLvlClass={"popupSizeLevel0"}
          closeOnEsc={false}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowInventoryAdjustmentModule}
          popupLvlClass={"popupSizeLevel0"}
          closeOnEsc={false}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
      </div>
    );
  }
}
export function CriteriaView(props) {
  const onChange = (e) => props.onChange(e);
  const fabricCodeOnChange = (e) => props.fabricCodeOnChange(e);
  let criteria = props.criteria;
  let fabricLookupHandler = props.fabricLookupHandler;
  let warehouseLookupHandler = props.warehouseLookupHandler;
  let binLookupHandler = props.binLookupHandler;
  let fabricCodeRef = React.createRef();
  let colorCodeRef = React.createRef();
  const onFabricColourCodeChange = (e) => {
    props.onFabricColourCodeChange(e);
  };
  const locationCodeOnChange = (e) => {
    props.locationCodeOnChange(e);
  };
  const binLocationCodeOnChange = (e) => {
    props.binLocationCodeOnChange(e);
  };
  const fabricEnterKeyEventHandler = (e) => {
    props.fabricEnterKeyEventHandler(e);
  };
  const displayAutoCompleteFabricList = () => {
    props.displayAutoCompleteFabricList();
  };
  const fabricColourEnterKeyEventHandler = (e) => {
    props.fabricColourEnterKeyEventHandler(e);
  };
  const displayAutoCompleteFabricColorList = () => {
    props.displayAutoCompleteFabricColorList();
  };
  const locationEnterKeyEventHandler = (e) => {
    props.locationEnterKeyEventHandler(e);
  };
  const displayAutoCompleteLocationList = () => {
    props.displayAutoCompleteLocationList();
  };
  const binLocationEnterKeyEventHandler = (e) => {
    props.binLocationEnterKeyEventHandler(e);
  };
  const displayAutoCompleteBinLocationList = () => {
    props.displayAutoCompleteBinLocationList();
  };
  return (
    <div>
      <Row className="d-flex justify-content-left">
        <Col sm="1">
          <FormLabel>BinLocation</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            onChange={binLocationCodeOnChange}
            name="binLocationCode"
            placeholder="binLocationCode"
            value={criteria.binLocationCode}
            lookupRequired={props.isShowBinLookup}
            lookupHandler={binLookupHandler}
            enterKeyEventHandler={binLocationEnterKeyEventHandler}
            autoCompleteListData={props.binLocationPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteBinLocationList}
            showAutoCompleteList={props.showAutoCompleteLocationList}
            disabled={props.isDisableFields}
            isMandatory={true}
          />
        </Col>
        <Col sm="1">
          <FormLabel>Location</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            onChange={locationCodeOnChange}
            name="locationCode"
            placeholder="location"
            value={criteria.locationCode}
            lookupRequired={props.isShowLookup}
            lookupHandler={warehouseLookupHandler}
            enterKeyEventHandler={locationEnterKeyEventHandler}
            autoCompleteListData={props.locationPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteLocationList}
            showAutoCompleteList={props.showAutoCompleteLocationList}
            disabled={props.isDisableFields}
          />
        </Col>
        {props.is3PL ? (
          <>
            <Col sm="1">
              <FormLabel>Customer</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={props.onCustomerCodeChange}
                disabled={props.isDisableFields}
                name="logisticCustomerCode"
                placeholder="Customer"
                value={criteria.logisticCustomerCode}
                lookupRequired={true}
                lookupHandler={props.customerLookupHandler}
                showCriteriaDialog={true}
                enterKeyEventHandler={props.customerCodeEnterKeyEventHandler}
                autoCompleteListData={props.customerPageListForAutoCompleteList}
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={props.displayAutoCompleteCustomerList}
                showAutoCompleteList={props.isShowAutoCompleteCustomerList}
                isMandatory={true}
              />
            </Col>
            <Col sm="3">
              <InputTextbox
                onChange={props.onCustomerCodeChange}
                disabled={true}
                name="customerName"
                value={criteria.customerName}
              />
            </Col>
          </>
        ) : null}

        <Col>
          <CollapseComponent
            isOpen={props.isCollapsible_open}
            onClick={(e) => props.showHideSecondHeader(e)}
          />
        </Col>
      </Row>
      {props.isCollapsible_open && (
        <>
          <Row>
            <Col sm="1">
              {props.is3PL ? (
                <FormLabel>Item</FormLabel>
              ) : (
                <FormLabel>FabricStyle</FormLabel>
              )}
            </Col>
            <Col sm="2">
              <InputTextbox
                ref={fabricCodeRef}
                name="fabricStyleCode"
                onChange={fabricCodeOnChange}
                value={criteria.fabricStyleCode}
                lookupRequired={props.isShowLookup}
                lookupHandler={fabricLookupHandler}
                showCriteriaDialog={true}
                enterKeyEventHandler={fabricEnterKeyEventHandler}
                autoCompleteListData={props.fabricPageListForAutoCompleteList}
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={displayAutoCompleteFabricList}
                showAutoCompleteList={props.showAutoCompleteFabricList}
                disabled={props.isDisableFields}
              />
            </Col>
            <Col sm="3">
              <InputTextbox
                name="fabricStyleName"
                onChange={onChange}
                value={criteria.fabricStyleName}
                disabled={true}
              />
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>Color</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                ref={colorCodeRef}
                onChange={onFabricColourCodeChange}
                name="colorCode"
                placeholder="color"
                value={criteria.colorCode}
                lookupRequired={props.isShowColorLookup}
                lookupHandler={props.colorLookupHandler}
                enterKeyEventHandler={fabricColourEnterKeyEventHandler}
                autoCompleteListData={
                  props.fabricColourPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={displayAutoCompleteFabricColorList}
                showAutoCompleteList={props.showAutoCompleteFabricColorList}
                disabled={props.isDisableFields}
              />
            </Col>
          </Row>
        </>
      )}
    </div>
  );
}
function BinLocationInventoryInquiry(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <BinLocationInventory {...props} name="" /> <br />
    </div>
  );
}
export default BinLocationInventoryInquiry;
